import { type TotalSummary as TotalSummaryResponse } from '@d3/contract';

import type { TotalSummary } from '../model/total-summary';

/**
 * 응답(@d3/contract indicator) → 메인 요약 뷰모델. 계약이 바뀐 필드명을 화면 이름으로 흡수한다.
 * invested→investTotal · investedPortfolioCount→investedPortfolio · totalValuation→valuationTotal ·
 * investable→investableTotal · completeExitCount→exitComplete · partialExitCount→exitPartial.
 * multiple 은 계약에서 null 가능 → 화면은 0 으로.
 */
export function toTotalSummary(res: TotalSummaryResponse): TotalSummary {
  return {
    aum: res.aum,
    investTotal: res.invested,
    investedPortfolio: res.investedPortfolioCount,
    multiple: res.multiple ?? 0,
    valuationTotal: res.totalValuation,
    investableTotal: res.investable,
    employeeTotal: res.employeeTotal,
    employeeIncrease: res.employeeIncrease,
    exitComplete: res.completeExitCount,
    exitPartial: res.partialExitCount,
  };
}
